export default __webpack_public_path__ + "static/media/webilo-cms.c4f38b25.png";